import { IAgency, IFile, IKase, IMasterNamePerson, IUser } from '@/models';
import { IInmate, IInmateHousing } from '@/pages/JMS/Managament/types/inmate';

export const MaritalStatus = {
  '1': 'Legally Married',
  '2': 'Single (never married)',
  '3': 'Divorced',
  '4': 'Widowed',
  '5': 'Separated',
  '6': 'Living Together/Common Law',
  '9': 'Unknown',
} as const;

export enum BookingType {
  NEW_ARREST = 'New Arrest',
  WARRANT_ARREST = 'Warrant Arrest',
  HOLD_FOR_OTHER_AGENCY = 'Hold for other Agency',
  COURT_INCARCERATED = 'Court Incarcerated',
}

export enum BookingStatus {
  IN_PROGRESS = 'In Progress',
  PROCESSED = 'Processed',
  COMPLETED = 'Completed',
}

export enum TabStatus {
  SUBMITTED = 'SUBMITTED',
  PENDING = 'PENDING',
}

export enum TabName {
  IDENTITY = 'identity',
  DETAILS = 'details',
  FINGERPRINTS = 'fingerprints',
  PROPERTIES = 'properties',
  MEDICAL = 'medical',
  LEGAL = 'legal',
  RISK_ASSESSMENT = 'risk',
  HOUSING = 'housing',
  NOTES = 'notes',
  BOOKING_HISTORY = 'booking-history',
}

export interface IBookingDetails {
  number?: string;
  agency?: IAgency | string;
  type?: BookingType;
  bookingOfficer?:
    | {
        _id: string;
        firstName: string;
        lastName: string;
      }
    | string;
  arrivalCredit?: string | null;
  initialBooking?: string | null;
  lastIntake?: string | null;
  kase?: IKase | string | null;
  bookingDisposition?: string;
  dischargeType?: string;
  scheduledReleaseDate?: string | null;
  actualReleaseDate?: string | null;
  bondPaymentDue?: string;
  chargeHousing?: boolean;
}

export interface IFingerprint {
  printedBy?: string | IUser;
  printedAt?: Date | string;
  files?: IFile[];
}

export interface IHousing {
  pod?: string;
  cell?: string;
  bed?: string;
}

export interface IBooking {
  _id?: string;
  agency?: IAgency | string;
  inmate?: IInmate;
  status?: BookingStatus;
  deleteReason?: string;
  identity?: Omit<IMasterNamePerson, 'createdAt' | 'updatedAt'>;
  details?: IBookingDetails;
  fingerprints?: IFingerprint;
  housing?: IHousing | IInmateHousing;
  submittedData?: Partial<Record<TabName, { status: TabStatus }>>;
}
